"use client";

import { Icon, IconProps } from "@ospweb/sdk-ui";

import { FC } from "react";
import { cn } from "utils";

interface IconHoverProps {
  title: string;
  align?: "left" | "top";
  disabled?: boolean;
  hoverClassName?: string;
}

export const IconHover: FC<IconHoverProps & IconProps> = ({
  title,
  align = "top",
  disabled = false,
  hoverClassName,
  ...props
}) => {
  return (
    <div className="group relative inline-flex cursor-pointer">
      <Icon {...props} />
      <span
        className={cn(
          `invisible  absolute z-10
          bg-background_solid_secondary text-content_tertiary p-1 rounded-1 body_medium_s whitespace-nowrap py-[4px] px-[6px] border border-border_white_transparent10`,
          {
            "left-1/2 -translate-x-1/2 top-[-32px]": align === "top",
            "top-[-2px] left-[27px]": align === "left",
            "group-hover:visible": !disabled,
          },
          hoverClassName,
        )}
      >
        {title}
      </span>
    </div>
  );
};
